import { z } from "zod";

export const organizationSchema = z.object({
	name: z.string().min(3, "Name must be at least 3 characters."),
	color: z.string().min(1, "Color is required."),
	size: z.string().min(1, "Size is required."),
	country: z.string().min(1, "Country is required."),
});

export type OrganizationFormType = z.infer<typeof organizationSchema>;
